// Font information
//-----------------------------
export const FONT_FAMILY = {
  default:
    'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  heading:
    '"Garet", Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  mono: 'SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace',
}

export const FONT_WEIGHTS = {
  normal: 400,
  bold: 600,
}

export const LINE_HEIGHTS = {
  fullHeight: 1,
  default: 1.5,
  header: 1.3,
}

// Font sizes
//-----------------------------
export const FONT_SIZES = {
  small: '0.875rem',
  default: '1rem',
  display3: '1.2rem',
  display2: '1.5rem',
  display1: '2rem',
}
